// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"385":"0b327c86","906":"8be7a69b"}[chunkId] + ".chunk.js";
};